import React from 'react';
import { Award } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const AchievementPopup = ({ achievement, isMobile }) => {
    const { theme } = useTheme();

    if (!achievement) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#8e44ad',
            padding: '40px',
            borderRadius: '10px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            textAlign: 'center',
            animation: 'achievementPop 0.5s ease-in-out',
            minWidth: isMobile ? '280px' : '400px'
        }}>
            <Award size={60} style={{ color: theme.text, marginBottom: '20px' }} />
            <h2 style={{
                color: theme.text,
                fontSize: isMobile ? '28px' : '36px',
                fontWeight: 'bold',
                margin: '0 0 10px 0',
                textTransform: 'uppercase'
            }}>
                Achievement Unlocked!
            </h2>
            <h3 style={{
                color: '#75bd4f',
                fontSize: isMobile ? '22px' : '28px',
                fontWeight: 'bold',
                margin: '0 0 10px 0'
            }}>
                {achievement.name}
            </h3>
            <p style={{
                color: theme.text,
                fontSize: isMobile ? '16px' : '18px',
                margin: '0 0 15px 0'
            }}>
                {achievement.description}
            </p>
            <p style={{
                color: '#75bd4f',
                fontSize: isMobile ? '18px' : '20px',
                fontWeight: 'bold',
                margin: '0'
            }}>
                +{achievement.reward_xp} XP
            </p>
        </div>
    );
};

export default AchievementPopup;
